import React, { Fragment } from 'react';
import Head from 'next/head';
import Jobs from 'src/components/Jobs';

import { getPositions } from 'src/services/jobs';
import { DOMAIN_URL } from 'src/config';
import useLocale from '../../../locales';

const positionsURL = `${DOMAIN_URL}/positions`;

function Positions({ positions, lang }) {
  const { positions: positionLocals } = useLocale(lang);
  const { title, description } = positionLocals.meta;
  return (
    <Fragment>
      <Head>
        <title>{title}</title>
        <meta key="description" name="description" content={description} />
        <meta key="og:title" property="og:title" content={title} />
        <meta
          key="og:description"
          property="og:description"
          content={description}
        />
        <meta key="og:url" property="og:url" content={positionsURL} />
        <meta key="twitter:title" property="twitter:title" content={title} />
        <meta
          key="twitter:description"
          property="twitter:description"
          content={description}
        />
      </Head>
      <Jobs positions={positions} lang={lang} />
    </Fragment>
  );
}

export async function getServerSideProps({ params: { lang = 'en' } }) {
  const positions = await getPositions(lang);

  return {
    props: {
      positions,
      lang,
    },
  };
}

export default Positions;
